import React, { useState, ReactNode } from 'react'
import { LoadingContext, LoadingContextType } from '../contexts/LoadingContext'

interface LoadingProviderProps {
  children: ReactNode
}

export const LoadingProvider: React.FC<LoadingProviderProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false)

  const showLoading = () => setIsLoading(true)
  const hideLoading = () => setIsLoading(false)

  const value: LoadingContextType = {
    isLoading,
    setIsLoading,
    showLoading,
    hideLoading
  }

  return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>
}
